<template>
  <div class="container container--narrow pdb-50">
      <div class="mgt-100 t-center">
          <img src="../../images/no-survey-data.svg" alt="" class="icon62 mgx-auto mgb-24">
          <div class="t-body1 t-center font-r t-color-bodyGrayA">{{$t('3057')}}</div>
      </div>
  </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>

